// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ic-0";
export var optionCard = "_ic-1";